// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  ComponentNameEnum,
  SocialNetworkIconStyleEnum,
  ElementPartTypeEnum,
  TemplateStructureEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import {
  setSocialNetworkOrientation,
  setSocialNetworkIconWidth,
  setSocialNetworkIconStyle,
  setActiveSharingSocialNetworks,
  setAttribute,
  setClass,
  setCssProperty,
  setMediaDisplay,
  setCssPropertyAndRemoveIfZero,
  sortSocialNetworks,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getActiveSocialNetworks,
  getAttributeByName,
  getClassByName,
  getCssPropertyByName,
  getSharingType,
  getSocialNetworkIconStyle,
  getSocialNetworksLinks,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import iconSizeFieldConfig from '@/components/template-builder/config/fields/icon-size-config';
// eslint-disable-next-line import/no-cycle
import inputGroupFieldConfig from '@/components/template-builder/config/fields/input-group-config';
// eslint-disable-next-line import/no-cycle
import getSpmSocialIconsFieldConfig from '@/components/template-builder/config/fields/spm-social-icons-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import getElementAlignFieldConfig from '@/components/template-builder/config/fields/element-align-config';
// eslint-disable-next-line import/no-cycle
import iconLayoutFieldConfig from '@/components/template-builder/config/fields/icon-layout-config';
// eslint-disable-next-line import/no-cycle
import getSharingTypeFieldConfig from '@/components/template-builder/config/fields/sharing-type-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import activeSharingSocialNetworksFieldConfig from '@/components/template-builder/config/fields/active-sharing-social-networks-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const widgetShareSocialMediaConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.shareSocialMedia',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.fields.iconLayout',
            selector: '{SELECTOR} > tbody > tr > th > table',
            properties: [{
              name: 'spm_social_icons_', getter: getClassByName, setters: [setClass, setSocialNetworkOrientation],
            }],
            ...iconLayoutFieldConfig,
          },
          {
            label: 'templateBuilder.fields.iconSize.label',
            selector: '{SELECTOR} > tbody > tr > th > table img',
            displayToggle: false,
            properties: [
              {
                name: 'width', getter: getAttributeByName, setters: [setAttribute, setSocialNetworkIconWidth],
              },
            ],
            ...iconSizeFieldConfig,
          },
          {
            label: 'templateBuilder.fields.iconStyle',
            selector: '{SELECTOR} > tbody > tr > th > table img',
            properties: [{ name: 'iconStyle', getter: getSocialNetworkIconStyle, setters: [setSocialNetworkIconStyle] }],
            ...getSpmSocialIconsFieldConfig(
              Object.values(SocialNetworkIconStyleEnum),
              SocialNetworkIconStyleEnum.STYLE_1,
            ),
          },
          {
            label: 'templateBuilder.fields.activeSocialNetworks',
            selector: '{SELECTOR} > tbody > tr > th > table',
            properties: [{
              name: 'activeNetworks', getter: getActiveSocialNetworks, setters: [setActiveSharingSocialNetworks], refreshWidgetFields: true,
            }],
            ...activeSharingSocialNetworksFieldConfig,
          },
          {
            label: 'templateBuilder.fields.socialNetworksLinks',
            selector: '{SELECTOR} > tbody > tr > th > table',
            properties: [{ name: 'socialNetworksLinks', getter: getSocialNetworksLinks, setters: [sortSocialNetworks] }],
            ...inputGroupFieldConfig,
            options: {
              draggable: true,
              displayFields: false,
            },
          },
          {
            label: 'templateBuilder.fields.sharingType',
            selector: '{SELECTOR} > tbody > tr > th > table',
            properties: [{ name: 'sharingType', getter: getSharingType, setters: [] }],
            ...getSharingTypeFieldConfig(),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.widgetBlockStyles',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.contentAlignment',
                  selector: '{SELECTOR} table',
                  properties: [{ name: 'align', getter: getAttributeByName, setters: [setAttribute] }],
                  ...getElementAlignFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.iconInnerMargins',
                  selector: '{SELECTOR} th td',
                  properties: [
                    {
                      name: 'padding-right',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  options: {
                    ...getVerticalSpacesFieldConfig('padding').options,
                    ...getHorizontalSpacesFieldConfig('padding').options,
                  },
                },
                {
                  label: 'templateBuilder.fields.marginVertical',
                  selector: '{SELECTOR} th, {SELECTOR} table',
                  properties: [
                    { name: 'margin-top', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'margin-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...getVerticalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.marginHorizontal',
                  selector: '{SELECTOR} th, {SELECTOR} table',
                  properties: [
                    { name: 'margin-left', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'margin-right', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...getHorizontalSpacesFieldConfig('margin'),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR}',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
                  ],
                  ...bordersFieldConfig,
                },
              ],
            },
            getWidgetCommonStylesGroup(),
          ],
        },
      },
      getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
    ],
  },
};

export default widgetShareSocialMediaConfig;
